import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'SuporteAtualizacaoDePdfStore' })
export default class SuporteAtualizacaoDePdfStore extends VuexModule {
  public solicitacoesIds: string = ''

  @Mutation
  setSolicitacoesIds(value: string) {
    this.solicitacoesIds = value
  }

  @Mutation
  clearSolicitacoesIds() {
    this.solicitacoesIds = ''
  }

  @Action
  async atualizarPDFs() {
    try {
      const params: any = {
        solicitacoesIds: this.solicitacoesIds.split('\n'),
      }

      const request = Apis.Agendamento.SuporteApi.atualizarPDFs(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
